import React from 'react';
import './Chat.css';

const ChatBubble = ({ message, isOutbound }) => {
  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'pending':
        return '🕐';
      case 'sent':
        return '✓';
      case 'delivered':
        return '✓✓';
      case 'failed':
        return '❌';
      default:
        return '';
    }
  };

  return (
    <div className={`chat-bubble ${isOutbound ? 'outbound' : 'inbound'}`}>
      <div className="message-content">
        {message.message}
      </div>
      <div className="message-meta">
        <span className="message-time">{formatTime(message.created_at)}</span>
        {isOutbound && (
          <span className="message-status">{getStatusIcon(message.status)}</span>
        )}
      </div>
    </div>
  );
};

export default ChatBubble;
